import { showSlideout } from '../../../Slideout/SlideoutReducer';
import { SLIDEOUTS } from '../../../Slideout/Slideouts';

export const JOB_RANGES_HIDE_SUMMARY_STATS = 'JOB_RANGES_HIDE_SUMMARY_STATS';
export const hideSummaryStats = () => ({ type: JOB_RANGES_HIDE_SUMMARY_STATS });
export const showSummaryDetails = () => (dispatch, getState) => {
  dispatch(showSlideout(SLIDEOUTS.JOB_RANGES_SUMMARY));
};
